export function filterAndSortInventory(rows, { qty, maxPrice, zone, tab }) {
  let out = (rows || []).filter((r) => (r.price == null || r.price <= maxPrice) && r.seats >= qty);
  if (zone) {
    out = out.filter((r) => r.zone === zone);
  }
  return out.slice().sort((a, b) => {
    if (!!a.ga !== !!b.ga) { return a.ga ? -1 : 1; }
    if (tab === 'best') {
      if (a.rank == null) { return 1; }
      if (b.rank == null) { return -1; }
      return a.rank - b.rank;
    }
    return (a.price || 0) - (b.price || 0);
  });
}

export function buildZoneSummaries(rows, { qty, maxPrice }) {
  const filtered = (rows || []).filter((r) => (r.price == null || r.price <= maxPrice) && r.seats >= qty);
  const byZone = {};
  filtered.forEach((r) => {
    const key = r.zone;
    if (!byZone[key]) {
      byZone[key] = {
        zone: key,
        label: r.category_label || r.name,
        ga: !!r.ga,
        table: !!r.table,
        gaSub: r.ga ? r.sub : null,
        minPrice: r.price != null ? Number(r.price) : null,
        count: 0,
      };
    }
    const z = byZone[key];
    z.count += 1;
    if (r.price != null) {
      const p = Number(r.price);
      if (z.minPrice == null || p < z.minPrice) { z.minPrice = p; }
    }
  });
  return Object.values(byZone).sort((a, b) => {
    if (!!a.ga !== !!b.ga) { return a.ga ? -1 : 1; }
    return (a.minPrice || 0) - (b.minPrice || 0);
  });
}

const groupSizes = (row) => {
  const units = row.ga_units || [];
  if (units.length === 0 || !units.every((u) => u.whole)) { return []; }
  const sizes = [...new Set(units.map((u) => u.units))].sort((a, b) => a - b);
  return sizes[0] > 1 ? sizes : [];
};

const priceGroup = (row) => {
  const sizes = groupSizes(row);
  if (sizes.length === 0) { return row; }
  const size = sizes[0];
  return {
    ...row,
    sub: sizes.length === 1 && size === 2 ? 'Sold in pairs' : `Sold in groups of ${sizes.join(' or ')}`,
    price: row.price == null ? null : row.price * size,
    original_price: row.original_price == null ? null : row.original_price * size,
    from_price: row.from_price || sizes.length > 1,
  };
};

export function simpleInventory(rows, { maxPrice, zone }) {
  return (rows || [])
    .filter((r) => (r.price == null || r.price <= maxPrice) && (!zone || r.zone === zone))
    .map(priceGroup)
    .sort((a, b) => ((a.position ?? Infinity) - (b.position ?? Infinity)) || ((a.price ?? Infinity) - (b.price ?? Infinity)));
}
